<template>
    <article class="result-card">
        <div class="result-card__image" v-if="!hideImage">
            <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
        </div>
        <div class="result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="resultItem.Link.Url">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <span class="visually-hidden">Support</span>
            </div>
            <div class="result-card__content flow max-width-s">
                <result-tags :tag-parents="resultItem.TagParents"></result-tags>

                <p>{{truncate(resultItem.Summary)}}</p>
            </div>
            <div class="result-card__footer">
                <a :href="resultItem.Link.Url" class="btn" v-if="resultItem.Link">
                    Find out more
                    <span class="visually-hidden"> about {{resultItem.Heading}}</span>
                </a>
                <profile-actions class="text-blue" 
                    :page-id="resultItem.Id.toString()"
                    :heading="resultItem.Heading"
                    v-if="resultItem.DocType=='event'
                    || resultItem.DocType=='newsArticle'
                    || resultItem.DocType=='gateway'
                    || resultItem.DocType=='report'
                    || resultItem.DocType=='product'
                    || resultItem.DocType=='property'">
                </profile-actions>
            </div>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    import ResultTags from '@/components/SiteSearch/result-tags'
    import { truncate } from '@/utils/strings.js'
    import { format, toDate } from '@/utils/date.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage,
            ResultTags
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            },
            hasTags(tagParents) {
                return Array.isArray(tagParents) && tagParents.some(group => group.Children && group.Children.length > 0)
            }
        },

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
            tagsToShow: {
                required: false,
                type: Array
            }
        }
        
    }
</script>